const pictures = {};
var missing = [3,5,6,12,13,23,25,27,41,60,71,81,82,84,88,92,93,96,97,98];
for (let i = 0; i<= 99; i++) {
	if (missing.includes(i)) continue;
	else pictures[i] = i+".jpg";
}

export default pictures;